import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-1669246f")
const _hoisted_1 = { class: "p-grid p-ai-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "p-col-6" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Estudiantes")
], -1)
const _hoisted_3 = { class: "p-col-6 p-text-right" }
const _hoisted_4 = { class: "p-col-12 p-text-right" }
const _hoisted_5 = { class: "p-grid" }
const _hoisted_6 = { class: "p-col" }
const _hoisted_7 = { class: "p-input-icon-right p-mt-3 p-mr-5" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_9 = { class: "p-col-fixed" }
const _hoisted_10 = ["for"]
const _hoisted_11 = { class: "p-col-12 data-table-container" }
const _hoisted_12 = { class: "p-col-12" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_ScrollPanel = _resolveComponent("ScrollPanel")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_LoadingScreen = _resolveComponent("LoadingScreen")!
  const _component_StudentsTable = _resolveComponent("StudentsTable")!
  const _component_BrainSpinner = _resolveComponent("BrainSpinner")!
  const _component_Paginator = _resolveComponent("Paginator")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_Button, {
        label: "Nuevo estudiante",
        class: "p-button-outlined",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({
                    name: 'createStudent'
                })))
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_InputText, {
              modelValue: _ctx.searchTxt,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchTxt = $event)),
              placeholder: "Buscar"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_Button, {
            type: "button",
            class: "p-text-left btn-custom-view",
            icon: "pi pi-chevron-down",
            iconPos: "right",
            label: 'Tabla',
            onClick: _ctx.toggle,
            "aria:haspopup": "true",
            "aria-controls": "overlay_panel_custom"
          }, null, 8, ["onClick"]),
          _createVNode(_component_OverlayPanel, {
            ref: "op",
            appendTo: "body",
            class: "p-mt-0 bg-gray-400",
            id: "overlay_panel_custom"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ScrollPanel, { style: {"width":"100%","max-height":"140px"} }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allColumns, (column) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: column.field,
                      class: "p-mb-2 p-d-flex p-ai-center"
                    }, [
                      _createVNode(_component_Checkbox, {
                        class: "p-m-2 bg-gray-400",
                        id: column.field,
                        name: "selectedColumns",
                        value: column[1].header,
                        modelValue: _ctx.showCol,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.showCol = $event)),
                        onClick: ($event: any) => (_ctx.clickCheck(column[1].header))
                      }, null, 8, ["id", "value", "modelValue", "onClick"]),
                      _createElementVNode("label", {
                        for: column.field
                      }, _toDisplayString(column[1].header), 9, _hoisted_10)
                    ]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 512)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_LoadingScreen, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(_component_StudentsTable, {
        showCol: _ctx.showCol,
        totalRecords: _ctx.totalRecords,
        students: _ctx.students,
        firstRecord: _ctx.firstVal,
        customFilterActive: _ctx.filters,
        allCoursePlans: _ctx.allCoursePlans,
        allColumns: _ctx.allColumns,
        selectedColumns: _ctx.selectedColumns,
        rows: _ctx.selectedRows,
        onUpdateFilters: _ctx.updateFilterListened,
        onUpdateSelectedRows: _ctx.addSelectedRow
      }, null, 8, ["showCol", "totalRecords", "students", "firstRecord", "customFilterActive", "allCoursePlans", "allColumns", "selectedColumns", "rows", "onUpdateFilters", "onUpdateSelectedRows"])
    ]),
    _createElementVNode("div", _hoisted_12, [
      (_ctx.loadingPaginator)
        ? (_openBlock(), _createBlock(_component_BrainSpinner, { key: 0 }))
        : (_openBlock(), _createBlock(_component_Paginator, {
            key: 1,
            onPage: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changePage($event))),
            rows: 10,
            totalRecords: (_ctx.totalRecords)
          }, null, 8, ["totalRecords"]))
    ])
  ]))
}